import { render, staticRenderFns } from "./RedAndTransfer.vue?vue&type=template&id=e0597234"
import script from "./RedAndTransfer.vue?vue&type=script&lang=js"
export * from "./RedAndTransfer.vue?vue&type=script&lang=js"
import style0 from "./RedAndTransfer.vue?vue&type=style&index=0&id=e0597234&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports